// test235
(235 && 0);
